module.exports = __webpack_public_path__ + "img/Staplar2.135ba7ea.png";